import { createI18n } from "vue-i18n";
import ru from "./ru";
import en from "./en";
import kk from "./kk";

const savedLocale = localStorage.getItem("locale") || "ru";

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: "ru",
  messages: { ru, en, kk },
});

export default i18n;
